import { PortalMessage } from 'portals-platform-lib';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { renderPropertyValue } from '../../utils/formatCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const InfoGridRow = ({
  configuredProperty,
  ticket
}) => {
  var _ticket$propertyName;
  const {
    propertyName,
    displayNameOverride
  } = configuredProperty;
  const propertyValue = (_ticket$propertyName = ticket === null || ticket === void 0 ? void 0 : ticket[propertyName]) !== null && _ticket$propertyName !== void 0 ? _ticket$propertyName : null;
  const formattedPropertyValue = renderPropertyValue(propertyValue, configuredProperty);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "heading-25",
      color: "text-core-subtle",
      marginBlockEnd: "0",
      children: /*#__PURE__*/_jsx(PortalMessage, {
        messageKey: "SUPPORT_SPACE_DETAIL_PAGE_TICKET_PROPERTIES",
        subKey: propertyName,
        fallback: displayNameOverride
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "div",
      typography: "body-100",
      marginBlockEnd: "0",
      children: formattedPropertyValue !== null && formattedPropertyValue !== void 0 ? formattedPropertyValue : '—'
    })]
  });
};